<template>
    <ModuleComponent 
        v-if="templateData"
        :templateData="templateData" 
        />
</template>

<script>
import ModuleComponent from '@vueapp/components/ModuleComponent.vue'
export default {
    name: 'Module',
    components: {
        ModuleComponent
    },
    data() {
        return {
            templateData: null
        }
    },
    props: {
        postSlug: String,
        postId: String
    },
    mounted() {
        // this.getData()
    },
    methods: {
    },

    async beforeCreate() {
        const params = new URLSearchParams(window.location.search),
            eParams = {}

        params.forEach((value, name) => {
            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+\ ]+)$/) ) {
                eParams[name] = value
            }
        })
        const paramsString = ( new URLSearchParams(eParams) ) .toString()

        const res = await fetch( BRYTER.homeUrl + '/module/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
            .then(response => response.json())
            .then(data => {
                this.templateData = data.template_data;
                // this.calendarOptions.events = JSON.parse(data.template_data.calendar_json) ?? [];
            })
            .catch(error => {
                console.error('Error fetching calendar data:', error);
            });
    }
}


</script>